/**
 * Big cursor images (48px, black with a white outline so they show on any
 * background). The same two values are written out in css/main.css for the
 * page; keep them identical.
 */
export const BIG_ARROW_CURSOR =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48'%3E%3Cpath d='M6 3v34l9-8.5 6.5 15 6-2.6-6.4-14.6H33z' fill='%23000' stroke='%23fff' stroke-width='2.5' stroke-linejoin='round'/%3E%3C/svg%3E\") 6 3, auto";

export const BIG_HAND_CURSOR =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48'%3E%3Cpath d='M17 5.5a3.5 3.5 0 0 1 7 0V19h1.5a3.3 3.3 0 0 1 6.5.8v.7a3.3 3.3 0 0 1 6.5.8v.9a3.2 3.2 0 0 1 5.5 2.3V33c0 7.6-5 12-12.5 12h-3.7c-4.6 0-7.6-2-10.4-5.8l-7.3-9.6a3.4 3.4 0 0 1 5.2-4.4L17 27z' fill='%23000' stroke='%23fff' stroke-width='2.5' stroke-linejoin='round'/%3E%3C/svg%3E\") 20 3, pointer";
